import { weededDocumentsApi } from "@api/weededDocuments/weededDocuments";
import React, { Component } from "react";
import { Button, Icon, Popup } from "semantic-ui-react";
import PropTypes from "prop-types";

export default class UnflagButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unflagging: false,
      success: false,
      error: null,
    };
    this._isMounted = false;
    this._reloadTimeout = null;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this._reloadTimeout) {
      clearTimeout(this._reloadTimeout);
      this._reloadTimeout = null;
    }
  }

  safeSetState = (newState) => {
    if (this._isMounted) {
      this.setState(newState);
    }
  };

  handleUnflag = async () => {
    const { documentPid, onSuccess, onError } = this.props;
    if (!documentPid) {
      return;
    }

    this.safeSetState({ unflagging: true, error: null, success: false });

    try {
      const data = await weededDocumentsApi.unflagDocument(documentPid);
      const apiSuccess = data.status === "success" && data.unflagged_count > 0;

      if (!apiSuccess) {
        throw new Error("API did not report successful unflag operation");
      }

      this.safeSetState({ success: true });

      if (onSuccess) {
        onSuccess(data, documentPid);
      }

      // Reload page after a delay to show the updated state
      this._reloadTimeout = setTimeout(() => {
        if (this._isMounted) {
          window.location.reload();
        }
      }, 2000);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Unknown error occurred";

      this.safeSetState({ error: errorMessage });

      if (onError) {
        onError(error);
      } else {
        alert(`Failed to exempt document from deletion: ${errorMessage}`);
      }
    } finally {
      this.safeSetState({ unflagging: false });
    }
  };

  render() {
    const { unflagging, success, error } = this.state;
    const {
      size = "tiny",
      compact = false,
      showText = true,
      disabled = false,
    } = this.props;

    const isDisabled = unflagging || disabled || success;
    const buttonColor = success ? "green" : "orange";
    const iconName = success ? "check" : "shield";

    const buttonContent = showText ? (
      <>
        <Icon name={iconName} />
        {success ? "Exempted" : "Exempt"}
      </>
    ) : null;

    let popupContent =
      "Remove this document from weeding (exempt from deletion).";
    if (error) {
      popupContent = `Error: ${error}`;
    } else if (success) {
      popupContent = "Document successfully exempted from deletion.";
    }

    return (
      <Popup
        trigger={
          <Button
            size={size}
            color={buttonColor}
            onClick={this.handleUnflag}
            loading={unflagging}
            disabled={isDisabled}
            compact={compact}
            icon={showText ? undefined : iconName}
            style={{ marginTop: "0px", padding: "7px" }}
          >
            {buttonContent}
          </Button>
        }
        content={popupContent}
        size="small"
        inverted
        position="top left"
      />
    );
  }
}

UnflagButton.propTypes = {
  documentPid: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  size: PropTypes.string,
  compact: PropTypes.bool,
  showText: PropTypes.bool,
  disabled: PropTypes.bool,
};
